import React from 'react';
import classnames from 'classnames';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useCurrentPromo } from '../../../utils/hooks/useCurrentPromo';
import { useCurrentUser } from '../../../utils/hooks/useCurrentUser';
import SaleBanner from '../../../SaleBanner';
import s from './UserGiftSaleBanner.scss';
/** A version of the SaleBanner specifically gifting an author from the DeviationPage */ const UserGiftSaleBanner = ({ className, user })=>{
    var _user, _user1, _user2, _currentPromo, _currentPromo1;
    const currentUser = useCurrentUser();
    const currentPromo = useCurrentPromo('gift');
    const currentUserIsRecipient = currentUser.userId === ((_user = user) === null || _user === void 0 ? void 0 : _user.userId);
    const isRegularUser = ((_user1 = user) === null || _user1 === void 0 ? void 0 : _user1.type) === 'regular';
    if (currentUserIsRecipient || !isRegularUser || !currentPromo) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(SaleBanner, {
        className: classnames(s['root'], className),
        giftRecipient: (_user2 = user) === null || _user2 === void 0 ? void 0 : _user2.username,
        endDate: (_currentPromo = currentPromo) === null || _currentPromo === void 0 ? void 0 : _currentPromo.endDate,
        discountValuePercent: (_currentPromo1 = currentPromo) === null || _currentPromo1 === void 0 ? void 0 : _currentPromo1.discountValuePercent,
        referralType: ReferralType.PROMOTION_BANNER_CONTENT_PAGE
    });
};
UserGiftSaleBanner.displayName = 'UserGiftSaleBanner';
export default UserGiftSaleBanner;
